var exports = {
  "L": "xa15a2ab7--a89949--loading",
  "E": "xa15a2ab7--a89949--overlap",
};

module.exports = exports;
